<app-rback [type]='21' [rurl]='rurl' theme='i-new'></app-rback> 

<div class="full-map-wrapper">
  <div class="qqmap-wrapper" id="tmap-full-map-wrapper"></div>
</div>